import { Store } from "@/stores/common/store.core";
import type { StoreJsonResponse } from "@/stores/common/store.core";
import type {
   GetNotificationsParams,
   GetNotificationsResponse,
} from "@laborchart-modules/lc-core-api/dist/api/notifications/get-user-notifications";
import type { GetUserUnreadNotificationsCountResponse } from "@laborchart-modules/lc-core-api/dist/api/notifications/get-user-notifications-count";
import type { NotificationViewedResponse } from "@laborchart-modules/lc-core-api/dist/api/notifications/notification-viewed";
import type { ClearNotificationsResponse } from "@laborchart-modules/lc-core-api/dist/api/notifications/clear-notifications";
export abstract class NotificationStore extends Store {
   static getNotifications(
      params: GetNotificationsParams,
   ): StoreJsonResponse<GetNotificationsResponse> {
      return this.requestJson({
         url: `/api/v3/notifications/user-notifications`,
         method: "GET",
         query: params,
      });
   }

   static getUnreadNotifications(
      params: GetNotificationsParams,
   ): StoreJsonResponse<GetNotificationsResponse> {
      return this.requestJson({
         url: `/api/v3/notifications/user-unread-notifications`,
         method: "GET",
         query: params,
      });
   }

   static getUnreadNotificationsCount(): StoreJsonResponse<GetUserUnreadNotificationsCountResponse> {
      return this.requestJson({
         url: `/api/v3/notifications/user-unread-notifications-count`,
         method: "GET",
      });
   }

   static notificationViewed(
      notificationId: string,
   ): StoreJsonResponse<NotificationViewedResponse> {
      return this.requestJson({
         url: `/api/v3/notifications/${notificationId}/viewed`,
         method: "PATCH",
      });
   }

   static clearAllNotifications(): StoreJsonResponse<ClearNotificationsResponse> {
      return this.requestJson({
         url: `/api/v3/notifications/clear-unread-notifications`,
         method: "PATCH",
      });
   }
}
